import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import styled from 'styled-components';
import SimpleLoading from '../../../common/SimpleLoading';
import parse from 'html-react-parser';
import { getPaymentStateLabel } from '../../../../pages/faculty/utils/getPaymentStateLabel';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    maxHeight: '80vh',
    bgcolor: 'background.paper',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const sanitizerHtml = (html) => {
    const string = 'src="/';
    const regex = new RegExp(string, 'g');
    return html.replace(regex, 'src="');
};

const ModalPurchaseOrder = ({ open, handleClose, purchaseOrder }) => {
    const isLoading = purchaseOrder === null;
    const hasError = purchaseOrder === false;
    const renderField = (label, value) =>
        value ? (
            <>
                <Label>{label}</Label>
                <Value>{value}</Value>
            </>
        ) : null;
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box sx={modalStyle}>
                {isLoading ? (
                    <Centered>
                        <SimpleLoading />
                    </Centered>
                ) : hasError ? (
                    <ErrorText>
                        No se pudieron cargar órdenes de pago.
                    </ErrorText>
                ) : (
                    <>
                        <Header>
                            Orden: <OrderCode>{purchaseOrder?.name}</OrderCode>
                        </Header>

                        <Section>
                            {renderField('Referencia', purchaseOrder?.ref)}
                            {renderField(
                                'Responsable',
                                purchaseOrder?.responsible
                            )}
                            {renderField(
                                'Fecha de solicitud',
                                purchaseOrder?.dateOrder
                            )}

                            {renderField('Notas', purchaseOrder?.notes)}

                            {renderField(
                                'Descripción',
                                purchaseOrder?.description
                            )}
                            {renderField(
                                'Notas',
                                purchaseOrder?.comments
                                    ? parse(
                                          sanitizerHtml(purchaseOrder?.comments)
                                      )
                                    : ''
                            )}
                            {purchaseOrder?.invoiceIds?.length &&
                                renderField(
                                    'Factura asociada',
                                    purchaseOrder.invoiceIds.map((invoice) => (
                                        <div key={invoice.id}>
                                            <div>Id: {invoice.id}</div>
                                            <div>
                                                Nombre Factura: {invoice.name}
                                            </div>
                                            <div>
                                                Estado Factura:{' '}
                                                {getPaymentStateLabel(
                                                    invoice.payment_state
                                                )}
                                            </div>
                                        </div>
                                    ))
                                )}
                        </Section>

                        <FooterGroup scrollable>
                            <KpiFooter>
                                {renderField(
                                    'Producto',
                                    purchaseOrder?.typeIdName
                                )}
                            </KpiFooter>
                            <KpiFooter>
                                {renderField(
                                    'Fecha de actividad',
                                    purchaseOrder?.activityDate
                                )}
                            </KpiFooter>
                            <KpiFooter>
                                {renderField(
                                    'Total',
                                    `${purchaseOrder?.currency || ''} ${purchaseOrder?.amount || ''}`
                                )}
                            </KpiFooter>
                        </FooterGroup>
                    </>
                )}
            </Box>
        </Modal>
    );
};

export default ModalPurchaseOrder;

const Centered = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 150px;
`;

const ErrorText = styled.p`
    color: red;
    font-weight: bold;
    text-align: center;
`;

const Header = styled.h2`
    color: #b31d15;
    font-size: 1.3rem;
    margin-bottom: 1rem;
`;

const OrderCode = styled.span`
    color: #222;
    font-weight: bold;
`;

const Section = styled.div`
    background-color: #f8f8f8;
    border-radius: 8px;
    padding: 1rem;
    margin-bottom: 1.5rem;
    min-height: auto;
    max-height: calc(70vh - 200px);
    overflow: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

const FooterGroup = styled.div`
    background-color: #f8f8f8;
    border-radius: 8px;
    padding: 1rem;
    margin-bottom: 1.5rem;
    max-height: 300px;
    overflow-y: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
`;

const KpiFooter = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
`;

const Label = styled.label`
    color: #b31d15;
    font-size: 0.95rem;
    font-weight: bold;
`;

const Value = styled.p`
    color: #222;
    font-size: 0.75rem;
    margin: 0;
`;
